<template>
  <div>
    <alerts-table v-if="existsRole('gestor-financeiro')" class="mb-4" />
    <Painel />
  </div>
</template>

<script setup>
import { useGetters } from "vuex-composition-helpers";
import Painel from "@/modules/central_consumo/Components/Painel.vue";
import AlertsTable from "@/modules/config/components/Home/AlertsTable.vue";

const { existsRole } = useGetters("auth", ["existsRole"]);
</script>

<style></style>
